import { Injectable } from '@angular/core';
import { Media} from '@ionic-native/media/ngx'; 
import { FileSystemService } from './file-system.service';
@Injectable({
  providedIn: 'root'
})
export class MediaService {
  public isFlashOn = false;
  constructor(public _media: Media, 
    public _fileSystem:FileSystemService) { }
  }